<template>
  <div class="grid-view">
    <div class="main-content account-title-balance">
      <div class="section operations">
        <div class="filters">
          <span style="margin-right: 5px">{{ $t('CargoMsg.Cargo_Category') }}</span>
          <el-button :type="assetsType" @click="categoryClickHandler(1)">{{ $t('FinanceManage.Assets') }}</el-button>
          <el-button :type="liabilityType" @click="categoryClickHandler(2)">{{ $t('FinanceManage.Liabilities') }}</el-button>
          <el-button :type="equityType" @click="categoryClickHandler(3)">{{ $t('FinanceManage.Equity') }}</el-button>
          <el-button :type="costType" @click="categoryClickHandler(4)">{{ $t('FinanceManage.Cost') }}</el-button>
          <el-button :type="interestType" @click="categoryClickHandler(5)">{{ $t('FinanceManage.ProfitAndLoss') }}</el-button>

          <el-button type="primary" @click="onSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <span style="margin: 0 10px 0 10px">{{ $t('CargoMsg.Cargo_Currency') }}</span>
          <el-select v-model="sourceCurrency" @change="currencyChangeHandler">
            <el-option v-for="item in currencys" :key="item" :label="item" :value="item" />
          </el-select>
          <span style="margin: 0 10px 0 10px">{{ $t('CargoMsg.Cargo_ExchangeRate')+' : '+exchangeRateValue }}</span>
          <el-checkbox v-if="!enableFinanceMultiCurrency" v-model="hideQuantity" :label="$t('CargoMsg.Cargo_HideQuantity')" style="margin-right: 10px" @change="hideQuantityHandler" />
          <el-button v-if="!enableFinanceMultiCurrency && showSaveBtn" type="primary" @click="saveBtnClickHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button v-if="!enableFinanceMultiCurrency" type="primary" @click="onSearch">{{ $t('CargoMsg.Cargo_InitialBalanceImport') }}</el-button>
          <el-upload
            v-if="enableFinanceMultiCurrency"
            :action="URL.finance.accountTitleAuxiliaryBalance.saveExcelFileByMultiCurrency"
            :headers="{sessionId: $store.getters.userInfo.sessionId}"
            :data="{accountSetUuid:accountSet.uuid}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeOrderUpload"
            :on-success="onImportSucceeded"
            :on-error="handleError"
            style="display: inline-block;margin-right: 10px"
          >
            <el-button type="primary">{{ $t('CargoMsg.Cargo_InitialBalanceImport') }}</el-button>
          </el-upload>
          <el-button v-if="enableFinanceMultiCurrency" type="primary" @click="downTemplateClickEvent">{{ $t('CargoMsg.Cargo_TemplateDownload') }}</el-button>
          <el-button type="primary" @click="balanceValidateHandler">{{ $t('CargoMsg.Cargo_TrialBalance') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-side-bar="false"
          :auto-fit-content="false"
          style="min-height: 500px"
        />
      </div>
      <title-auxiliary-dialog
        :visible.sync="titleAuxiliaryDialog.visible"
        :account-set="titleAuxiliaryDialog.accountSet"
        :account-title="titleAuxiliaryDialog.accountTitle"
        :account-title-balance="titleAuxiliaryDialog.accountTitleBalance"
        :fiscal-period="titleAuxiliaryDialog.fiscalPeriod"
        :currency="titleAuxiliaryDialog.currency"
        :is-multi-currency="titleAuxiliaryDialog.isMultiCurrency"
        @close="titleAuxiliaryDialogCloseHandler"
      />
      <balance-validate-dialog
        :visible.sync="balanceValidateDialog.visible"
        :account-set="balanceValidateDialog.accountSet"
        :fiscal-period="balanceValidateDialog.fiscalPeriod"
      />
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import TitleAuxiliaryDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleBalanceList/components/TitleAuxiliaryDialog'
import AccountTitleEditDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleEditDialog'
import BalanceValidateDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleBalanceList/components/BalanceValidateDialog'
import { DocumentManage } from '@/utils/commonUtil'
import { cache } from '@/utils/cacheManager'
import AccountTitleBalanceHeader from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleBalanceList/components/AccountTitleBalanceHeader'
import AccountTitleBalanceRenderer from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleBalanceList/components/AccountTitleBalanceRenderer'
import * as accountTitleBalanceCurrencyApi from '@/api/financeManage/accountTitleBalanceCurrency'
import * as accountTitleBalanceApi from '@/api/financeManage/accountTitleBalance'
import * as accountTitleApi from '@/api/financeManage/accountTitle'
import URL from '@/api/urlTranslator'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'

export default {
  name: 'AccountTitleBalanceList',
  components: { BalanceValidateDialog, AccountTitleEditDialog, TitleAuxiliaryDialog },
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      URL: URL,
      showSaveBtn: false,
      fiscalPeriod: null,
      balances: [],
      accountTitleBalances: [],
      rates: [],
      currencys: [],
      sourceCurrency: '',
      exchangeRateValue: '1.0000',
      hideQuantity: false,
      documentManage: new DocumentManage(),
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true,
          suppressMovable: true,
          headerClass: 'text-center'
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          AccountTitleBalanceHeader,
          AccountTitleBalanceRenderer
        },
        onRowDoubleClicked: this.doubleClickHandler,
        onRowClicked: (event) => { this.selectedItem = event.data }
      },
      rowData: [],
      locked: true,
      assetsType: '',
      liabilityType: '',
      equityType: '',
      costType: '',
      interestType: '',
      accountTitleType: 1,
      titleAuxiliaryDialog: {
        visible: false,
        accountSet: null,
        accountTitle: null,
        fiscalPeriod: null,
        accountTitleBalance: null,
        currency: '',
        isMultiCurrency: false
      },
      balanceValidateDialog: {
        visible: false,
        accountSet: null,
        fiscalPeriod: null
      },
      selectedItem: null, // 表格选中项
      loading: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
          field: 'accountTitle',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleName'),
          field: 'accountTitleName',
          width: 100,
          valueFormatter: params => {
            return this.nameLabelFun(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Direction'),
          field: 'debitCrebit',
          width: 100,
          valueFormatter: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Debit') : this.$t('CargoMsg.Cargo_Credit')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'sourceCurrency',
          width: 100,
          hide: !this.enableFinanceMultiCurrency
        }, {
          headerName: this.$t('CargoMsg.Cargo_OpeningBalance'),
          width: 300,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
              field: 'accountingQuantity',
              width: 100,
              hide: this.enableFinanceMultiCurrency,
              valueFormatter: params => {
                return this.quantityLabelFun(params.value)
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_OriginalCurrency'),
              field: 'sourceBeginningBalance',
              width: 100,
              hide: !this.enableFinanceMultiCurrency
            }, {
              headerName: this.enableFinanceMultiCurrency ? this.$t('CargoMsg.Cargo_LocalCurrency') : this.$t('CargoMsg.Cargo_Amount'),
              field: 'beginningBalance',
              width: 100,
              valueFormatter: params => {
                return params.value !== 0 ? Number(params.value).toFixed(2) : ''
              }
            }
          ]
        }
      ]
    },
    enableFinanceMultiCurrency() {
      return cache.config.get('enableFinanceMultiCurrency') === '1'
    },
    standardCurrency() {
      return this.$t('CargoMsg.Cargo_ConsolidatedLocalCurrency')
    }
  },
  created() {
    if (this.accountSet) {
      this.getCurrentFiscalPeriod()
    }
    this.categoryClickHandler(this.accountTitleType)
  },
  beforeMount() {

  },
  methods: {
    onSearch() {
      this.rowData = []
      if (this.accountSet) {
        const object = {}
        object.accountTitleType = this.accountTitleType
        object.accountSetUuid = this.accountSet.uuid
        object.initialPeriod = 1
        object.sourceCurrency = this.sourceCurrency
        if (this.sourceCurrency === this.standardCurrency) {
          if (this.enableFinanceMultiCurrency) {
            object.sourceCurrency = ''
            accountTitleBalanceCurrencyApi.loadAccountTitleBalanceCurrencies(object).then(resp => {
              this.loadAccountTitleBalanceCurrencyHandler(resp)
            })
          } else {
            accountTitleBalanceApi.loadAccountTitleBalance(object).then(resp => {
              this.loadAccountTitleBalanceHandler(resp)
            })
          }
        } else {
          accountTitleBalanceCurrencyApi.loadAccountTitleBalanceCurrencies(object).then(resp => {
            this.loadAccountTitleBalanceCurrencyHandler(resp)
          })
        }
      }
      this.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
    },
    loadAccountTitleBalanceHandler(resp) {
      this.accountTitleBalances = []
      this.balances = []
      this.rowData = this.filterDataProvider(resp.data)
    },
    loadAccountTitleBalanceCurrencyHandler(resp) {
      // AccountTitleBalance Entity
      this.balances = resp.data.balances
      // AccountTitleBalance DTO
      this.accountTitleBalances = this.filterDataProvider(resp.data.accountTitleBalances)
      // Datagrid DataProvider
      let datas = this.filterDataProvider(resp.data.balanceCurrencies)
      datas = this.summaryCurrentCurrencyBalance(datas)
      this.rowData = datas
    },
    summaryCurrentCurrencyBalance(datas) {
      for (const item of datas) {
        if (item.level === 1) {
          let i = 0
          for (const item2 of datas) {
            if (item.accountTitle === item2.accountItem1 && item2.level > 1) {
              if (i === 0) {
                item.beginningBalance = 0.0
              }
              item.beginningBalance += item2.beginningBalance
              i++
            }
          }
        }
      }
      return datas
    },
    filterDataProvider(value) {
      let flag = false
      for (const item of value) {
        item.initialPeriod = this.fiscalPeriod.initialPeriod
        flag = this.hasSubAccountTitleBalance(item, value)
        item.hasSubAccountTitleBalance = flag
        item.currency = this.sourceCurrency
        item.rate = Number(this.exchangeRateValue)
        item.enableFinanceMultiCurrency = this.enableFinanceMultiCurrency
        if (this.balances) {
          item.accountTitleBalance = this.getAccountTitleBalance(item.accountTitle)
        }
      }
      return value
    },
    hasSubAccountTitleBalance(object, value) {
      if (!object || !this.fiscalPeriod.accountSetUuid || object.level === this.accountSet.accountTitleGradeRule.length) {
        return false
      }
      const level = object.level
      const subLevel = level + 1
      for (const item of value) {
        if (item.LEVEL === subLevel && item.accountTitleType === object.accountTitleType) {
          let itemFlag = true
          for (var i = 1; i < subLevel; i++) {
            if (item['accountItem' + i] === object['accountItem' + i]) {
              continue
            }
            // 有不相同的accountItem
            itemFlag = false
          }
          if (itemFlag) {
            return true
          }
        }
      }
      return false
    },
    categoryClickHandler(code) {
      this.assetsType = ''
      this.liabilityType = ''
      this.equityType = ''
      this.costType = ''
      this.interestType = ''
      this.accountTitleType = code
      const type = 'info'
      switch (code) {
        case 1:
          this.assetsType = type
          break
        case 2:
          this.liabilityType = type
          break
        case 3:
          this.equityType = type
          break
        case 4:
          this.costType = type
          break
        case 5:
          this.interestType = type
          break
        default:
      }
      this.loadList()
    },
    nameLabelFun(params) {
      let result = ''
      if (params.value) {
        for (let i = 1; i < params.data.level; i++) {
          result += '    '
        }
        result += params.value.toString()
      }
      return result
    },
    loadList() {
      this.onSearch()
    },
    async getCurrentFiscalPeriod() {
      await accountTitleBalanceCurrencyApi.getUsedCurrencyAndFiscalPeriod({ accountSetUuid: this.accountSet.uuid }).then(resp => {
        this.getCurrentFiscalPeriodHandler(resp)
      })
    },
    getCurrentFiscalPeriodHandler(resp) {
      const result = resp.data
      const usedCurrency = result.usedCurrency
      this.setCurrencyDDLDataProvider(usedCurrency)
      this.fiscalPeriod = result.currentFiscalPeriod
      this.setPrivilege(this.fiscalPeriod)
      this.rates = result.rates ? result.rates : []
      this.onSearch()
    },
    setCurrencyDDLDataProvider(value) {
      this.currencys = null
      if (value) {
        value.splice(0, 0, this.standardCurrency)
      }
      this.currencys = value
      this.sourceCurrency = this.standardCurrency
    },
    setPrivilege(fiscalPeriod) {
      if (this.$checkPermission(['button_AccountSetFinanceInitUpdate'])) {
        if (fiscalPeriod && fiscalPeriod.initialPeriod) {
          if (this.sourceCurrency && this.sourceCurrency === this.standardCurrency) {
            this.showSaveBtn = false
          } else {
            this.showSaveBtn = true
          }
        } else {
          this.showSaveBtn = false
        }
      } else {
        this.showSaveBtn = false
      }
    },
    currencyChangeHandler(currency) {
      if (currency === this.standardCurrency) {
        this.exchangeRateValue = '1.0000'
        if (!this.enableFinanceMultiCurrency) {
          this.gridOptions.columnApi.setColumnVisible('sourceBeginningBalance', false)
          const beginningBalanceColumn = this.gridOptions.columnApi.getAllColumns.find(column => column.field === 'beginningBalance')
          beginningBalanceColumn.headerName = this.$t('CargoMsg.Cargo_Amount')
        }
      } else if (currency === this.accountSet.localCurrency) {
        this.exchangeRateValue = '1'
        if (!this.enableFinanceMultiCurrency) {
          this.gridOptions.columnApi.setColumnVisible('sourceBeginningBalance', false)
          const beginningBalanceColumn = this.gridOptions.columnApi.getAllColumns.find(column => column.field === 'beginningBalance')
          beginningBalanceColumn.headerName = this.$t('CargoMsg.Cargo_Amount')
        }
      } else {
        this.exchangeRateValue = this.getRate(currency).toString()
        if (!this.enableFinanceMultiCurrency) {
          this.gridOptions.columnApi.setColumnVisible('sourceBeginningBalance', true)
          const beginningBalanceColumn = this.gridOptions.columnApi.getAllColumns.find(column => column.field === 'beginningBalance')
          beginningBalanceColumn.headerName = this.$t('CargoMsg.Cargo_LocalCurrency')
        }
      }
      this.setPrivilege(this.fiscalPeriod)
      this.onSearch()
    },
    getRate(code) {
      for (const rate of this.rates) {
        if (rate.sourceCurrency === code) {
          return rate.rate
        }
      }
      return 0
    },
    doubleClickHandler(event) {
      console.log(event)
      this.selectedItem = event.data
      const cell = this.gridOptions.api.getFocusedCell()
      if (!cell) return
      // const item = cell ? this.rowData[cell.rowIndex] : null
      const item = cell ? this.selectedItem : null
      const colId = cell.column.colId
      const valid = ['accountingQuantity', 'sourceBeginningBalance', 'beginningBalance'].includes(colId)
      if (valid && item && (this.sourceCurrency !== this.standardCurrency || this.enableFinanceMultiCurrency)) {
        const params = {}
        params.accountingSetKey = this.accountSet.uuid
        params.accountTitle = item.accountTitle
        accountTitleApi.getAccountTitleByBalanceCurrency(params).then(resp => {
          this.getAccountTitleByBalanceCurrencyHandler(resp)
        })
      }
    },
    getAccountTitleByBalanceCurrencyHandler(resp) {
      const accountTitle = resp.data
      if (!accountTitle.auxiliaryCustomer && !accountTitle.auxiliarySupplier && !accountTitle.auxiliarySales && !accountTitle.auxiliaryDepartment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SADNSUICAT'))
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      // const item = cell ? this.rowData[cell.rowIndex] : null
      const item = cell ? this.selectedItem : null
      const params = {}
      params.accountSet = this.accountSet
      params.accountTitle = accountTitle
      params.fiscalPeriod = this.fiscalPeriod
      params.accountTitleBalance = item
      params.currency = this.sourceCurrency
      params.isMultiCurrency = this.enableFinanceMultiCurrency
      Object.assign(this.titleAuxiliaryDialog, params)
      this.titleAuxiliaryDialog.visible = true
    },
    getAccountTitleBalance(accountTitle) {
      for (const item of this.balances) {
        if (item.accountTitle === accountTitle) {
          return item
        }
      }
      return null
    },
    quantityLabelFun(params) {
      return params.value ? params.data.quantity : ''
    },
    hideQuantityHandler(value) {
      this.gridOptions.columnApi.setColumnVisible('accountingQuantity', !value)
    },
    balanceValidateHandler() {
      this.balanceValidateDialog.accountSet = this.accountSet
      this.balanceValidateDialog.fiscalPeriod = this.fiscalPeriod
      this.balanceValidateDialog.visible = true
    },
    saveBtnClickHandler() {
      if (this.accountTitleType === 5) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NNTEIBOPLBFSOATBOTY'))
        return
      }
      if (this.sourceCurrency !== this.standardCurrency) {
        const saveCollection = this.caculateBalance()
        const params = {}
        params.fiscalPeriod = this.fiscalPeriod
        params.balanceCurrencys = saveCollection
        accountTitleBalanceCurrencyApi.saveBachAccountTitleBalanceCurrency(params).then(resp => {
          this.onSearch()
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        })
      }
    },
    caculateBalance() {
      const result = []
      let balance
      let atbCurrency
      // 计算被改变的AccountTitleBalanceCurrency
      for (const gridItem of this.rowData) {
        balance = gridItem.accountTitleBalance
        atbCurrency = this.getBalanceCurrency(balance, gridItem)
        atbCurrency.sourceBeginningBalance = Number(gridItem.sourceBeginningBalance)
        atbCurrency.beginningBalance = Number(gridItem.beginningBalance)
        result.push(atbCurrency)
      }
      return result
    },
    getBalanceCurrency(accountTitleBalance, data) {
      if (!accountTitleBalance || !data) {
        return null
      }
      for (const item of accountTitleBalance.accountTitleBalanceCurrency) {
        if (item.sourceCurrency === data.currency) {
          return item
        }
      }
      return null
    },
    titleAuxiliaryDialogCloseHandler() {
      this.titleAuxiliaryDialog.visible = false
    },
    async onImportSucceeded(result) {
      this.loading.close()
      var msg = result.data['msg']
      var insertResult = result.data['insertResult']
      if (insertResult != null && insertResult.length > 0) {
        await this.$confirm(this.$t('CargoMsg.Cargo_UCOVEIIDPCTD'))
        this.exportErrorExcel(insertResult)
      } else {
        msg = msg.replace('records.', this.$t('CargoMsg.Cargo_Pcst'))
        msg = msg.split(':')[1]
        msg += this.$t('CargoMsg.Cargo_RITSS')
        this.$message.success(msg)
      }
      this.currencyChangeHandler()
    },
    exportErrorExcel(insertResult) {
      const self = this
      const rows = insertResult
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          this.$t('CargoMsg.Cargo_AccountTitleCode'),
          this.$t('FinanceManage.ClientSupplier'),
          this.$t('CargoMsg.Cargo_Staff'),
          this.$t('CargoMsg.Cargo_Department'),
          this.$t('CargoMsg.Cargo_Direction'),
          this.$t('FinanceManage.BalanceInRMB'),
          this.$t('CargoMsg.Cargo_BalanceUSD')
        ]
        const filterVal = ['accountTitleCode', 'accountName', 'staffName', 'departmentName', 'debitCrebit', 'balanceCurrencyRmb', 'balanceCurrencyUsd']

        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.$t('FinanceManage.UnmatchedClientOrSupplier')
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    downTemplateClickEvent() {
      ExportUtils.downloadTemplateFile('AccountTitleBalanceTemplate.xls', 'financeInterface')
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    handleError(error) {
      this.loading.close()
    }
  }
}
</script>

<style scoped>
  .ag-header-cell-label { justify-content: center; }
</style>
